export default __webpack_public_path__ + "static/fall37-53ad66bc3c03826457baa6af01f16b4a.webp";